import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../features/theme/themeSlice";
import stemlabLog from "../../assets/logo.png";

// style imports
import {
  AppBar,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Avatar,
  SwipeableDrawer,
  Tooltip,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import {
  LightMode,
  DarkMode,
  AccountCircle,
  ChevronLeft,
  ChevronRight,
  Menu as MenuIcon,
  ManageAccounts,
  Dashboard,
  MarkEmailRead,
  Contact,
  Contacts,
} from "@mui/icons-material";

import {
  toggleLogin,
  toggleSignUp,
  toogleTwoFactorChallengeModal,
} from "../../features/modals/modalSlice";
import { logoutUser, postVerifyDevEmail } from "../../features/Auth/authSlice";

import { useNavigate, Link } from "react-router-dom";
import MenuList from "../Backend/MenuList";
import Login from "./Login";
import SignUp from "./SignUp";
import { persistor } from "../../app/store";
import TwoFactorChallangeModal from "../Auth/TwoFactorChallangeModal";
import SnackBar from "./SnackBar";

const Navbar = () => {
  const route = window.location.href;

  const navigate = useNavigate();

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [openSignupModal, setOpenSignupModal] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { mode } = useSelector((state) => state.theme);
  const { loginModal } = useSelector((state) => state.modal);
  var { dev } = useSelector((state) => state.dev);

  // var { dev: checkDev } = dev;

  console.log(dev?.verified);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate("/dev/dashboard");
  //   } else {
  //     navigate("/");
  //     dispatch(toggleLogin());
  //   }
  // }, []);

  const purge = () => {
    persistor.purge();
  };

  const toggleOpenLogin = () => {
    dispatch(toggleLogin());
  };
  const toggleOpenSignUp = () => {
    dispatch(toggleSignUp());
  };

  //? drawe methods
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const drawerWidth = 400;

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
    height: "50vh",
  }));

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="sticky">
          <Toolbar>
            {!isLoggedIn && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ display: { xs: "flex", md: "none" } }}
                onClick={() => setMobileMenu(!mobileMenu)}
              >
                {" "}
                <MenuIcon />
              </IconButton>
            )}
            {isLoggedIn && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={handleDrawerOpen}
              >
                {" "}
                <MenuIcon />
              </IconButton>
            )}
            {/* {route === `http://localhost:3000/dev/dashboard` && <MenuIcon />}
          {route === `http://localhost:3000/dev/skills` && <MenuIcon />}
          {route === `http://localhost:3000/dev/projects` && <MenuIcon />} */}

            <Box
              sx={{
                display: "flex",
                flexGrow: 1,
                ml: 5,
                float: "left",
                // justifyContent: "flex-end",
              }}
            >
              <Link to="/">
                <Box
                  sx={{
                    borderRadius: "10px",
                    bgcolor: "white",
                  }}
                  width={100}
                  height="100%"
                  component="img"
                  src={stemlabLog}
                  p={1}
                />
              </Link>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexGrow: 1,
                ml: 5,
                float: "right",
                justifyContent: "flex-end",
              }}
            >
              <Stack
                // divider={<Divider orientation="vertical" />}
                orientation="vertical"
                direction="row"
                // spacing={2}
                spacing={{ xs: 1, sm: 1, md: 1 }}
              >
                <Button
                  // disabled={isLoggedIn && !dev?.verified}
                  color="inherit"
                  component="a"
                  href="/devs"
                >
                  Devs
                </Button>
                {!isLoggedIn && (
                  <Button
                    sx={{ display: { xs: "none", md: "flex" } }}
                    color="inherit"
                    onClick={toggleOpenLogin}
                  >
                    Login
                  </Button>
                )}
                {!isLoggedIn && (
                  <Button
                    sx={{ display: { xs: "none", md: "flex" } }}
                    color="inherit"
                    onClick={toggleOpenSignUp}
                  >
                    Sign Up
                  </Button>
                )}

                <IconButton
                  onClick={() => dispatch(toggleTheme())}
                  aria-label="lightmode"
                  color="secondary"
                >
                  {mode === "dark" ? <LightMode /> : <DarkMode />}
                </IconButton>
                {isLoggedIn && (
                  <Button
                    sx={{ display: { xs: "none", md: "flex" } }}
                    color="inherit"
                    onClick={() => dispatch(logoutUser())}
                  >
                    Log Out
                  </Button>
                )}

                {isLoggedIn && !dev?.verified && (
                  <Tooltip title="Click to verify your email">
                    <span>
                      <Button
                        sx={{ display: { xs: "none", sm: "flex" } }}
                        underline="none"
                        button
                        component="button"
                        // href="/dev/dashboard"
                        onClick={() => dispatch(postVerifyDevEmail())}
                        // {dev?.dev?.verified && disabled }
                        // disabled={!dev?.verified}
                      >
                        <Avatar
                          sx={{ display: { xs: "none", sm: "flex" } }}
                          alt="veriify email address"
                        >
                          <MarkEmailRead />
                        </Avatar>
                      </Button>
                    </span>
                  </Tooltip>
                )}
                {isLoggedIn && dev?.verified && (
                  <Button
                    sx={{ display: { xs: "none", sm: "flex" } }}
                    underline="none"
                    button
                    component="button"
                    href={`/devs/${dev.id}`}
                  >
                    <Avatar
                      sx={{ display: { xs: "none", sm: "flex" } }}
                      alt="Settings"
                    >
                      <Contacts />
                    </Avatar>
                  </Button>
                )}
                {isLoggedIn && (
                  <>
                    {!dev?.verified ? (
                      <Tooltip title="Please verify your email to access your Dashboard">
                        <span>
                          <Button disabled>
                            <Avatar
                              sx={{ display: { xs: "none", sm: "flex" } }}
                              alt="Dashboard"
                            >
                              <Dashboard />
                            </Avatar>
                          </Button>
                        </span>
                      </Tooltip>
                    ) : (
                      <Button
                        sx={{ display: { xs: "none", sm: "flex" } }}
                        underline="none"
                        button
                        component="button"
                        href="/dev/dashboard"
                        // {dev?.dev?.verified && disabled }
                        // disabled={!dev?.verified}
                      >
                        <Avatar
                          sx={{ display: { xs: "none", sm: "flex" } }}
                          alt="Dashboard"
                        >
                          <Dashboard />
                        </Avatar>
                      </Button>
                    )}
                  </>
                )}
                {isLoggedIn && (
                  <>
                    {!dev?.verified ? (
                      <Tooltip title="Please verify your email to access your profile settings">
                        <span>
                          <Button disabled>
                            <Avatar
                              sx={{ display: { xs: "none", sm: "flex" } }}
                              alt="Settings"
                            >
                              <ManageAccounts />
                            </Avatar>
                          </Button>
                        </span>
                      </Tooltip>
                    ) : (
                      <Button
                        sx={{ display: { xs: "none", sm: "flex" } }}
                        underline="none"
                        button
                        component="button"
                        href="/dev/settings"
                        // {dev?.dev?.verified && disabled }
                        // disabled={!dev?.verified}
                      >
                        <Avatar
                          sx={{ display: { xs: "none", sm: "flex" } }}
                          alt="Settings"
                        >
                          <ManageAccounts />
                        </Avatar>
                      </Button>
                    )}
                  </>
                )}
              </Stack>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>

      <SwipeableDrawer
        anchor="left"
        open={mobileMenu}
        onClose={() => setMobileMenu(!mobileMenu)}
        // onOpen={() => setMobileMenu(mobileMenu)}
        // sx={{
        //   width: drawerWidth,
        // }}
        // width="500px"
        sx={{
          display: "flex",
          flexGrow: 1,
          ml: 5,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button color="error" size="small">
          <IconButton onClick={() => setMobileMenu(!mobileMenu)}>
            {theme.direction === "ltr" ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
        </Button>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            // ml: 5,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack
            divider={<Divider orientation="horizontal" />}
            // orientation="vertical"
            direction="column"
            spacing={2}
            sx={{
              width: "250px",
            }}
          >
            <Button color="inherit" component="a" href="/devs">
              Devs
            </Button>
            {!isLoggedIn && (
              <Button color="inherit" onClick={toggleOpenLogin}>
                Login
              </Button>
            )}
            {!isLoggedIn && (
              <Button color="inherit" onClick={toggleOpenSignUp}>
                Sign Up
              </Button>
            )}

            <Button variant="outlined" color="secondary">
              <IconButton
                onClick={() => dispatch(toggleTheme())}
                aria-label="lightmode"
              >
                {mode === "dark" ? <LightMode /> : <DarkMode />}
              </IconButton>
            </Button>

            {isLoggedIn && (
              <Button color="inherit" onClick={() => dispatch(logoutUser())}>
                Log Out
              </Button>
            )}

            {/* {isLoggedIn && (
              <>
                {!dev?.verified ? (
                  <Tooltip title="Please verify your email to access your Dashboard">
                    <span>
                      <Button disabled>
                        <Avatar
                          sx={{ display: { xs: "none", sm: "flex" } }}
                          alt="Dashboard"
                        >
                          <Dashboard />
                        </Avatar>
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <Button
                    sx={{ display: { xs: "none", sm: "flex" } }}
                    underline="none"
                    button
                    component="button"
                    href="/dev/dashboard"
                    // {dev?.dev?.verified && disabled }
                    // disabled={!dev?.verified}
                  >
                    <Avatar
                      sx={{ display: { xs: "none", sm: "flex" } }}
                      alt="Dashboard"
                    >
                      <Dashboard />
                    </Avatar>
                  </Button>
                )}
              </>
            )}
            {isLoggedIn && (
              <>
                {!dev?.verified ? (
                  <Tooltip title="Please verify your email to access your profile settings">
                    <span>
                      <Button disabled>
                        <Avatar
                          sx={{ display: { xs: "none", sm: "flex" } }}
                          alt="Settings"
                        >
                          <ManageAccounts />
                        </Avatar>
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <Button
                    sx={{ display: { xs: "none", sm: "flex" } }}
                    underline="none"
                    button
                    component="button"
                    href="/dev/settings"
                    // {dev?.dev?.verified && disabled }
                    // disabled={!dev?.verified}
                  >
                    <Avatar
                      sx={{ display: { xs: "none", sm: "flex" } }}
                      alt="Settings"
                    >
                      <ManageAccounts />
                    </Avatar>
                  </Button>
                )}
              </>
            )} */}
          </Stack>
        </Box>
      </SwipeableDrawer>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItmes: "center",
            float: "left",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItmes: "center",
              float: "left",
            }}
          >
            <Stack
              divider={<Divider orientation="vertical" />}
              spacing={{ xs: 0.2, sm: 1, md: 1 }}
              orientation="vertical"
              direction="row"
              // spacing={2}
              // sx={{
              //   display: "flex",
              //   justifyContent: "center",
              //   alignItmes: "center",
              //   float: "left",
              // }}
            >
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === "ltr" ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>

              {isLoggedIn && !dev?.verified && (
                <Tooltip title="Click to verify your email">
                  <span>
                    <Button
                      // sx={{ display: { xs: "none", sm: "flex" } }}
                      underline="none"
                      button
                      component="button"
                      // href="/dev/dashboard"
                      onClick={() => dispatch(postVerifyDevEmail())}
                      // {dev?.dev?.verified && disabled }
                      // disabled={!dev?.verified}
                    >
                      <Avatar
                        // sx={{ display: { xs: "none", sm: "flex" } }}
                        alt="veriify email address"
                      >
                        <MarkEmailRead />
                      </Avatar>
                    </Button>
                  </span>
                </Tooltip>
              )}
              {isLoggedIn && dev?.verified && (
                <Button
                  // sx={{ display: { xs: "none", sm: "flex" } }}
                  underline="none"
                  button
                  component="button"
                  href={`/devs/${dev.id}`}
                >
                  <Avatar
                    // sx={{ display: { xs: "flex", sm: "flex" } }}
                    alt="Settings"
                  >
                    <Contacts />
                  </Avatar>
                </Button>
              )}
              {isLoggedIn && (
                <>
                  {!dev?.verified ? (
                    <Tooltip title="Please verify your email to access your Dashboard">
                      <span>
                        <Button disabled>
                          <Avatar
                            // sx={{ display: { xs: "none", sm: "flex" } }}
                            alt="Dashboard"
                          >
                            <Dashboard />
                          </Avatar>
                        </Button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Button
                      // sx={{ display: { xs: "none", sm: "flex" } }}
                      underline="none"
                      button
                      component="button"
                      href="/dev/dashboard"
                      // {dev?.dev?.verified && disabled }
                      // disabled={!dev?.verified}
                    >
                      <Avatar
                        // sx={{ display: { xs: "none", sm: "flex" } }}
                        alt="Dashboard"
                      >
                        <Dashboard />
                      </Avatar>
                    </Button>
                  )}
                </>
              )}
              {isLoggedIn && (
                <>
                  {!dev?.verified ? (
                    <Tooltip title="Please verify your email to access your profile settings">
                      <span>
                        <Button disabled>
                          <Avatar
                            // sx={{ display: { xs: "none", sm: "flex" } }}
                            alt="Settings"
                          >
                            <ManageAccounts />
                          </Avatar>
                        </Button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Button
                      // sx={{ display: { xs: "none", sm: "flex" } }}
                      underline="none"
                      button
                      component="button"
                      href="/dev/settings"
                      // {dev?.dev?.verified && disabled }
                      // disabled={!dev?.verified}
                    >
                      <Avatar
                        // sx={{ display: { xs: "none", sm: "flex" } }}
                        alt="Settings"
                      >
                        <ManageAccounts />
                      </Avatar>
                    </Button>
                  )}
                </>
              )}

              {isLoggedIn && (
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={() => dispatch(logoutUser())}
                >
                  Log Out
                </Button>
              )}
            </Stack>
          </Box>
        </DrawerHeader>
        <Divider />
        <MenuList />
      </Drawer>

      {/* login Modal */}

      <Login />
      <SignUp />
      <TwoFactorChallangeModal />
      <SnackBar />
    </>
  );
};

export default Navbar;
